var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortTableAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50994 7.21697C6.31994 7.21697 6.12994 7.14697 5.97994 6.99697L0.969941 1.98697C0.679941 1.69697 0.679941 1.21697 0.969941 0.926973C1.25994 0.636973 1.73994 0.636973 2.02994 0.926973L7.03994 5.93697C7.32994 6.22697 7.32994 6.70697 7.03994 6.99697C6.88994 7.14697 6.69994 7.21697 6.50994 7.21697Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48999 19.207C1.07999 19.207 0.73999 18.867 0.73999 18.457V1.45703C0.73999 1.04703 1.07999 0.707031 1.48999 0.707031C1.89999 0.707031 2.23999 1.04703 2.23999 1.45703V18.457C2.23999 18.867 1.90999 19.207 1.48999 19.207Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortTableAsc);
export default __webpack_public_path__ + "static/media/sort-table-asc.ceee9f817e4f7c6df0248b063c37c979.svg";
export { ForwardRef as ReactComponent };